import { MediaTool } from '@calm/evexia-web-sdk';

export function sortTools(a: MediaTool, b: MediaTool) {
    if (a.position === b.position) {
        return 0;
    }
    return a.position > b.position ? 1 : -1;
}
